import {
  CustomSchoolStatus,
  CustomSchoolStatusLabels,
  customSchoolStatusSchema,
  SchoolStatus,
  schoolStatusSchema,
} from '@airreading/common/data';

export const getCustomStatusLabel = (status: CustomSchoolStatus | null | undefined): string =>
  status ? CustomSchoolStatusLabels[status] : 'Unknown';

export const getCustomSchoolStatusOptions = () =>
  customSchoolStatusSchema.options.map((status) => ({
    label: getCustomStatusLabel(status),
    value: status,
  }));

export const schoolAccountStatusLabels: Record<SchoolStatus, string> = {
  active: 'Active',
  inactive: 'Inactive',
};

export const getSchoolAccountStatusOptions = () =>
  schoolStatusSchema.options.map((status) => ({
    label: schoolAccountStatusLabels[status],
    value: status,
  }));
